import { useState, useCallback } from 'react';
import { UploadedFileInfo } from '../services/api';

export interface UseFileUploadReturn {
  uploadedFiles: Record<string, UploadedFileInfo>;
  handleFileUpload: (documentType: string) => (fileInfo: UploadedFileInfo) => void;
  handleFileRemoved: (documentType: string) => () => void;
}

/**
 * Hook para gerenciar o estado de upload de arquivos.
 */
export function useFileUpload(): UseFileUploadReturn {
  const [uploadedFiles, setUploadedFiles] = useState<Record<string, UploadedFileInfo>>({});

  const handleFileUpload = useCallback(
    (documentType: string) => (fileInfo: UploadedFileInfo) => {
      setUploadedFiles((prev) => ({
        ...prev,
        [documentType]: fileInfo,
      }));
    },
    []
  );

  const handleFileRemoved = useCallback(
    (documentType: string) => () => {
      setUploadedFiles((prev) => {
        const newFiles = { ...prev };
        delete newFiles[documentType];
        return newFiles;
      });
    },
    []
  );

  return {
    uploadedFiles,
    handleFileUpload,
    handleFileRemoved,
  };
}
